import * as Scrivito from "scrivito";

export default function configureObjClassForContentType() {
  Scrivito.configureObjClassForContentType({
    "text/javascript": "Plugin",
    "image/*": "Image",
    "video/*": "Video",
    "*/*": "Download",
  });
}
